function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "feedback",
  transform: "translate(0 -0.001)"
}, React.createElement("path", {
  id: "Path_3569",
  "data-name": "Path 3569",
  d: "M7.708,19c1.842-3.191,1.67-3.066,1.716-3.066H20.339a1.609,1.609,0,0,0,1.588-1.626V2.618a.746.746,0,0,0-1.49,0V14.309c0,.08-.052.136-.1.136H9.424c-.859,0-1.3,1.045-1.886,2.5L5.631,15.023a1.57,1.57,0,0,0-1.214-.578H1.588c-.046,0-.1-.056-.1-.136V1.627c0-.08.052-.136.1-.136H20.339c.046,0,.1.056.1.136v.831a.746.746,0,0,0,1.49,0V1.627A1.609,1.609,0,0,0,20.339,0H1.588A1.609,1.609,0,0,0,0,1.627V14.309a1.609,1.609,0,0,0,1.588,1.626H4.417a.086.086,0,0,1,.064.035A33.878,33.878,0,0,1,7.708,19Z",
  transform: "translate(0)",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_3571",
  "data-name": "Path 3571",
  d: "M81.614,56.406H71.849c-.923,0-.924,1.549,0,1.549h9.765C82.537,57.955,82.539,56.406,81.614,56.406Zm0,0",
  transform: "translate(-65.707 -52.263)",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_3572",
  "data-name": "Path 3572",
  d: "M81.614,95.941H71.849c-.923,0-.924,1.549,0,1.549h9.765C82.537,97.491,82.539,95.941,81.614,95.941Zm0,0",
  transform: "translate(-65.707 -88.895)",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_3573",
  "data-name": "Path 3573",
  d: "M81.614,135.477H71.849c-.923,0-.924,1.549,0,1.549h9.765C82.537,137.026,82.539,135.477,81.614,135.477Zm0,0",
  transform: "translate(-65.707 -125.527)",
  fill: "#fff"
}));
var SvgFeedback = function SvgFeedback(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 21.928,
    height: 19,
    viewBox: "0 0 21.928 19",
    ref: svgRef
  }, props), _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFeedback, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feedback.48f92ae3.svg";
export { ForwardRef as ReactComponent };